import { IState } from "./state";
import { ActionTree, Store, ActionContext } from 'vuex';
import * as api from '../api';
import { ISearchParams } from "../api";
import qs from 'query-string';

type PayloadType = 'initApp' | 'setState'
| 'search' | 'setLoading' 
| 'setItems' | 'setTotal'

export type ActionPayload<ActionData> = {
	type: PayloadType,
	payload: ActionData
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;


// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
	type: 'initApp',
	payload: state
})

export const search: ActionCreator<string> = (payload) => ({
	type: 'search',
	payload
})

// Action handlers
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}

const searchAction: ActionHandler<string> = ({ commit, state }, { payload }) => {

	const searchParams: ISearchParams = {
		numberToShow: state.numberToShow,
	}

	commit({
		type: 'setLoading',
		payload: true
	})

	api.search(state.url, searchParams)
		.then(res => {
			commit({
				type: 'setItems',
				payload: res.items
			})
			commit({
				type: 'setTotal',
				payload: res.total
			})
		})

	commit({
		type: 'setLoading',
		payload: false
	})

	let url = `?${qs.stringify(searchParams)}`;
	window.history.replaceState({}, document.title, url);
}

const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	search: searchAction
}

export default actions;
